import React, {ComponentPropsWithoutRef} from 'react';
import styled from "styled-components";
import {Text18} from "./Typography";

interface DateChipProps extends ComponentPropsWithoutRef<'time'> {
    ISO: string;
}

const formatDate = (dateStr: string) => {
    return new Intl.DateTimeFormat('en-US').format(new Date(dateStr));
};

const DateChip = ({ISO, ...props}: DateChipProps) => {
    return (
        <Chip {...props} dateTime={ISO}>
            {formatDate(ISO)}
        </Chip>
    );
};

export default DateChip;

const Chip = styled(Text18).attrs({as: 'time'})`
    width: fit-content;
    padding: 5px 11px;
    border: 1px solid #000000;
    border-radius: 4px;
    letter-spacing: 1px;
`;
